// Ordenação padrão: inscrição mais recente primeiro (created_at da inscrição; fallback id).
// Colunas sortáveis: # (id da inscrição) e Candidato.

export function parseIsoToMs(value) {
  if (value == null || value === '') return null;
  let str = String(value).trim();
  if (!str) return null;
  if (str.includes('T') && !str.includes('Z') && !str.includes('+') && !str.match(/[+-]\d{2}:\d{2}$/)) {
    str = str.replace(/(\.\d+)?$/, '$1Z');
  }
  const t = new Date(str).getTime();
  return Number.isFinite(t) ? t : null;
}

export function applicationRegistrationMs(app) {
  const t = parseIsoToMs(app?.created_at);
  if (t != null) return t;
  const id = Number(app?.id);
  return Number.isFinite(id) ? id : 0;
}

export function appealRegistrationMs(appeal) {
  const t = parseIsoToMs(appeal?.application_created_at);
  if (t != null) return t;
  const id = Number(appeal?.application_id);
  return Number.isFinite(id) ? id : 0;
}

export function exemptionRequestRegistrationMs(row) {
  const t = parseIsoToMs(row?.application_created_at);
  if (t != null) return t;
  const id = Number(row?.application_id);
  return Number.isFinite(id) ? id : 0;
}

export function sarRowRegistrationMs(row, appById) {
  const app = appById?.get?.(row.application_id);
  if (app) {
    const t = parseIsoToMs(app.created_at);
    if (t != null) return t;
  }
  const t2 = parseIsoToMs(row?.created_at);
  if (t2 != null) return t2;
  const id = Number(row?.application_id);
  return Number.isFinite(id) ? id : 0;
}

function cmpRegistrationApplications(a, b) {
  const ca = applicationRegistrationMs(a);
  const cb = applicationRegistrationMs(b);
  if (ca !== cb) return cb - ca;
  return Number(b.id) - Number(a.id);
}

function cmpRegistrationApplicationsAsc(a, b) {
  const ca = applicationRegistrationMs(a);
  const cb = applicationRegistrationMs(b);
  if (ca !== cb) return ca - cb;
  return Number(a.id) - Number(b.id);
}

export function sortApplicationsForDisplay(list, sortState, options = {}) {
  const copy = [...list];
  if (!sortState?.key) {
    copy.sort(options.registrationOrderAsc ? cmpRegistrationApplicationsAsc : cmpRegistrationApplications);
    return copy;
  }
  const { key, dir } = sortState;
  const mul = dir === 'desc' ? -1 : 1;
  if (key === 'id') {
    copy.sort((a, b) => {
      const c = mul * (Number(a.id) - Number(b.id));
      if (c !== 0) return c;
      return cmpRegistrationApplications(a, b);
    });
  } else if (key === 'registered_at') {
    copy.sort((a, b) => {
      const ca = applicationRegistrationMs(a);
      const cb = applicationRegistrationMs(b);
      const c = mul * (ca - cb);
      if (c !== 0) return c;
      return mul * (Number(a.id) - Number(b.id));
    });
  } else {
    copy.sort((a, b) => {
      const c = mul * String(a.candidate_name || '').localeCompare(String(b.candidate_name || ''), 'pt-BR');
      if (c !== 0) return c;
      return cmpRegistrationApplications(a, b);
    });
  }
  return copy;
}

function cmpRegistrationAppeals(a, b) {
  const ca = appealRegistrationMs(a);
  const cb = appealRegistrationMs(b);
  if (ca !== cb) return cb - ca;
  return Number(b.application_id || 0) - Number(a.application_id || 0);
}

export function sortAppealsForDisplay(list, sortState) {
  const copy = [...list];
  if (!sortState?.key) {
    copy.sort(cmpRegistrationAppeals);
    return copy;
  }
  const { key, dir } = sortState;
  const mul = dir === 'desc' ? -1 : 1;
  if (key === 'id') {
    copy.sort((a, b) => {
      const c = mul * (Number(a.application_id) - Number(b.application_id));
      if (c !== 0) return c;
      return cmpRegistrationAppeals(a, b);
    });
  } else {
    copy.sort((a, b) => {
      const c = mul * String(a.candidate_name || '').localeCompare(String(b.candidate_name || ''), 'pt-BR');
      if (c !== 0) return c;
      return cmpRegistrationAppeals(a, b);
    });
  }
  return copy;
}

function cmpRegistrationExemptionRows(a, b) {
  const ca = exemptionRequestRegistrationMs(a);
  const cb = exemptionRequestRegistrationMs(b);
  if (ca !== cb) return cb - ca;
  return Number(b.application_id || 0) - Number(a.application_id || 0);
}

export function sortExemptionRequestsForDisplay(list, sortState) {
  const copy = [...list];
  if (!sortState?.key) {
    copy.sort(cmpRegistrationExemptionRows);
    return copy;
  }
  const { key, dir } = sortState;
  const mul = dir === 'desc' ? -1 : 1;
  if (key === 'id') {
    copy.sort((a, b) => {
      const c = mul * (Number(a.application_id) - Number(b.application_id));
      if (c !== 0) return c;
      return cmpRegistrationExemptionRows(a, b);
    });
  } else {
    copy.sort((a, b) => {
      const c = mul * String(a.candidate_name || '').localeCompare(String(b.candidate_name || ''), 'pt-BR');
      if (c !== 0) return c;
      return cmpRegistrationExemptionRows(a, b);
    });
  }
  return copy;
}

function cmpRegistrationSar(a, b, appById) {
  const ca = sarRowRegistrationMs(a, appById);
  const cb = sarRowRegistrationMs(b, appById);
  if (ca !== cb) return cb - ca;
  return Number(b.application_id) - Number(a.application_id);
}

export function sortSarRowsForDisplay(list, sortState, appById) {
  const copy = [...list];
  if (!sortState?.key) {
    copy.sort((a, b) => cmpRegistrationSar(a, b, appById));
    return copy;
  }
  const { key, dir } = sortState;
  const mul = dir === 'desc' ? -1 : 1;
  if (key === 'id') {
    copy.sort((a, b) => {
      const c = mul * (Number(a.application_id) - Number(b.application_id));
      if (c !== 0) return c;
      return cmpRegistrationSar(a, b, appById);
    });
  } else {
    copy.sort((a, b) => {
      const c = mul * String(a.candidate_name || '').localeCompare(String(b.candidate_name || ''), 'pt-BR');
      if (c !== 0) return c;
      return cmpRegistrationSar(a, b, appById);
    });
  }
  return copy;
}

export const initialAdminTableSort = () => ({ key: null, dir: 'desc' });

/** Primeiro clique: Nº = maior primeiro; Candidato / Inscrição = A–Z ou mais antiga primeiro. */
export function nextAdminTableSort(prev, columnKey) {
  if (prev.key !== columnKey) {
    const ascFirst = columnKey === 'candidate' || columnKey === 'registered_at';
    return { key: columnKey, dir: ascFirst ? 'asc' : 'desc' };
  }
  return { key: columnKey, dir: prev.dir === 'desc' ? 'asc' : 'desc' };
}

export function sortColumnIndicator(sortState, columnKey) {
  if (!sortState || sortState.key !== columnKey) return '';
  return sortState.dir === 'desc' ? ' \u25BC' : ' \u25B2';
}
